import { useSnlInvoiceStore } from 'stores/SNLInvoiceStore'
import { PageTracker } from '..'
import { PagePropsAbstract } from 'components/pageNavigator'
import { useNavigate } from 'react-router-dom'
import { useSNLSkipPassword } from 'modules/sleepNewLeads/hooks/useSNLSkipPassword'

const SnlReview = ({
  ...pageProps
}: PagePropsAbstract ): JSX.Element => {

  const { setSnlPaymentCompleted } = useSnlInvoiceStore()
  const { canSkipPassword } = useSNLSkipPassword()
  const navigate = useNavigate()

  const handleNext = () => {
    setSnlPaymentCompleted( true )

    // already logged in and not using HealthTap
    if ( canSkipPassword ) {
      return navigate( `/account` )
    }

    return pageProps.nextPage()
  }

  return (
    <div className="sm:mx-auto lg:mx-0 max-w-[672px] relative">
      <PageTracker
        title="Review"
        description=""
      />
      <div className="flex flex-col items-center gap-[15px] w-full">
        <p className="text-center text-[14px] font-semibold font-inter text-[#222222] leading-[16.94px] mb-2">
          {`Upon verifying your insurance coverage, we will provide updates by email, text, or phone call.`}
        </p>
        <p className="text-center text-[14px] font-normal font-inter text-[#222222] leading-[16.94px]">
          {`You'll receive an estimated cost based on your insurance coverage before an order is ever shipped.`}
        </p>
        <p className="sm:mx-auto lg:mx-0 max-w-[672px] text-center text-[14px] font-semibold font-inter text-[#222222] leading-[16.94px] sm:leading-[19px]">
          {`Upon placing your order, our team will verify your insurance and obtain all necessary paperwork from your doctor per your insurance guidelines.`}
        </p>
      </div>

      <div className="flex flex-col items-center w-full pt-5 pr-1 pb-10 pl-1 gap-5">
        <p className="w-full text-[12px] font-inter font-normal leading-[14.52px] text-[#222222]">
          {`By continuing, I authorize Aeroflow Healthcare to contact me by email, phone, or SMS. Aeroflow will not share or distribute this information. I also agree to `}
          <a
            href="/terms-and-conditions"
            className="text-[#0057A8] underline"
          >
            {`Aeroflow Terms and Conditions`}
          </a>
          {`.`}
        </p>

        <div className="mx-auto w-80 mt-6 space-y-6">
          <button
            className="btn btn-primary"
            onClick={handleNext}
            data-testid="snl-review-next-button"
          >
            {`Next`}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SnlReview